exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.big.el-select[data-v-5f59c278] {\n  width: 450px;\n}\n.el-autocomplete[data-v-5f59c278] {\n  width: 440px;\n}\n.my-autocomplete li[data-v-5f59c278] {\n  line-height: normal;\n  padding: 3px;\n}\n.my-autocomplete li .value[data-v-5f59c278] {\n    text-overflow: clip;\n    font-size: 9px;\n    overflow: hidden;\n    color: #6d728b;\n    white-space: normal;\n}\n.my-autocomplete li .link[data-v-5f59c278] {\n    text-overflow: clip;\n    font-size: 10px;\n    color: #33408a;\n    white-space: normal;\n}\n.bigger.el-select[data-v-5f59c278] {\n  width: 620px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f59c278","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roleSpecific/PresidentDecision.vue
// module id = y/9e
// module chunks = 1